/* istanbul ignore file */
import React from 'react';
import { usePurchaseOrderUrl } from 'domain/finance/purchaseOrder/shared/usePurchaseOrderRouting';
import { CREATE_PURCHASE_ORDER } from 'domain/finance/purchaseOrder/usePurchaseOrderService';
import { CreateButton } from 'framework/ui/ui-builder';

const CreatePurchaseOrderButton = () => {
  const { getCreateUrl } = usePurchaseOrderUrl();

  return (
    <CreateButton
      url={getCreateUrl()}
      label="Add purchase order"
      key="create-purchase-order"
      permissionToCheck={CREATE_PURCHASE_ORDER}
    />
  );
};

export default CreatePurchaseOrderButton;
